import { render, staticRenderFns } from "./CustomSelectsRoleOfIcon.vue?vue&type=template&id=5b00da60&"
import script from "./CustomSelectsRoleOfIcon.vue?vue&type=script&lang=js&"
export * from "./CustomSelectsRoleOfIcon.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectsRoleOfIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VRow,VSelect})
